import { render, staticRenderFns } from "./tab-terms.vue?vue&type=template&id=ce0e517e&scoped=true"
import script from "./tab-terms.vue?vue&type=script&lang=ts"
export * from "./tab-terms.vue?vue&type=script&lang=ts"
import style0 from "./tab-terms.vue?vue&type=style&index=0&id=ce0e517e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ce0e517e",
  null
  
)

export default component.exports